import React, {Component} from "react";
import axios from "axios";
import LoadingIcon from "./icons/LoadingIcon";
import SortIcon from "./icons/SortIcon";
// import SortAscIcon from "./icons/SortAscIcon";

class OverviewTable extends Component{
    constructor(props) {
        super(props);
        this.state = {
            domain: this.props.domain,
            selected_metric: "AER",
            show_loading: true,
            models: null,
            datasets: null,
            table: null,
            sorted_by: "",
            asc: null
            // settings: {"s": true, "p": true, "w": true, "m": false},
            // pie_chart_color: {"possible": "rgba(2,132,199,1)", "sure": "#65a30d", "missing": "#ea8034", "wrong": "#dc2626"},
        }
    }


    changeSelectedMetric = (metric) =>{
        this.setState({
            selected_metric: metric,
            sorted_by: "",
            asc: null
        }, ()=>{
            // this.drawBarChart();
            // this.styleSelectedBarchartBar();
            // this.drawScatterPlot()
        })
    }

    componentDidMount() {
        const {domain} = this.state;
        var url = domain+"api/getTable"
        axios.get(url)
            .then(res => {
                this.setState({
                    models: res.data.models,
                    datasets: res.data.datasets,
                    table: res.data.table,
                    show_loading: false,
                },()=>{ });
            });
    }

    sortBy = (arr, prop)=> {
        const {selected_metric} = this.state
        return arr.sort((a, b) => a["datasets"][prop][selected_metric] - b["datasets"][prop][selected_metric]);
    }

    sortByVal= (v)=>{
        const {table, sorted_by, asc} = this.state
        let sorted = this.sortBy(table, v)
        let _asc = true
        if(sorted_by===v && asc!==null){
            if(asc){
                sorted = sorted.reverse()
                _asc = false
            }
        }
        this.setState({
            table: sorted,
            sorted_by: v,
            asc: _asc
        })
    }

    render() {
        const {selected_metric, show_loading, datasets, table, sorted_by} = this.state
        let selected_metric_css = "px-2 py-1 bg-neutral-700 rounded text-xs text-white m-1 hover:bg-gray-800"
        let default_metric_css = "px-2 py-1 border border-gray-300 rounded text-xs text-gray-600 m-1  hover:bg-gray-200"

        return (
            <div>
                {show_loading?
                    <div className="flex m-auto justify-center"><LoadingIcon /></div>:
                    <div className="block text-center">
                        <div>
                            <button className={selected_metric==="AER"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("AER")}}>AER</button>
                            <button className={selected_metric==="precision"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("precision")}}>Precision</button>
                            <button className={selected_metric==="recall"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("recall")}}>Recall</button>
                            <button className={selected_metric==="f1"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("f1")}}>F1</button>
                            <button className={selected_metric==="tp"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("tp")}}># Translation Pairs</button>
                            <button className={selected_metric==="coverage"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("coverage")}}>Coverage</button>
                            <button className={selected_metric==="pac"?selected_metric_css:default_metric_css}
                                    onClick={()=>{this.changeSelectedMetric("pac")}}>PAC</button>
                        </div>
                        <div className="block text-center">
                            <table className="table-auto m-auto mt-5">
                                <thead>
                                <tr className="px-4 text-sm text-left text-justify leading-relaxed " >
                                    <td className="m-2 px-2 py-1 border-b  text-xs text-white font-bold
                                        bg-neutral-700"> Models/Datasets</td>
                                    {datasets.map(ds=>{
                                        return <td className="m-2 px-2 py-1 border   text-xs text-yellow-400
                                        bg-neutral-700 hover:cursor-pointer"

                                                   key={"td_header_"+ds.title}>
                                           <a href={"main?ds="+ds.id} className="hover:underline text-white">
                                            {this.state.sorted_by===ds.title?(
                                                    <span>
                                                    <b className="text-yellow-400">{ds.title}</b>


                                                        {/*{this.state.asc?*/}
                                                        {/*    <SortAscIcon />*/}
                                                        {/*    :*/}
                                                        {/*    <SortDescIcon />*/}
                                                        {/*}*/}
                                                    </span>)
                                                :ds.title}</a> <span className="font-bold " onClick={()=>{this.sortByVal(ds.title)}}>
                                            <SortIcon />
                                        </span>
                                        </td>
                                    })}
                                </tr>
                                </thead>
                                <tbody>
                                {/*{models.map(model=>{*/}
                                {/*    return (<tr><td className="m-2 px-2 py-1 border-b*/}
                                {/*        text-neutral-700 rounded text-xs border-r"*/}
                                {/*                    key={"td_"+model.title}>{model.title}</td>*/}
                                {/*    {datasets.map(ds=>{*/}
                                {/*        return <td className="m-2 px-2 py-1 border-b  rounded text-xs "*/}
                                {/*                   key={"td_"+ds.title+"_"+model.title} >*/}
                                {/*            {table[model.title][ds.title][selected_metric]}</td>*/}
                                {/*    })}*/}
                                {/*    </tr>)*/}
                                {/*})}*/}
                                {table.map((model, index)=>{

                                    return (<tr className={"hover:bg-neutral-700 hover:text-white " + (index%2===0?" bg-neutral-200":"")}>
                                        <th className="m-2 px-2 py-1 border-b  hover:border text-xs border-r "
                                            key={"td_"+model.title}><a href={"/model?m="+model.id} className="hover:underline">{model.title}</a></th>
                                        {datasets.map(ds=>{
                                            return <td className={"m-2 px-2 py-1 border text-xs " + (sorted_by===ds.title?" bg-neutral-400 font-bold hover:text-white": "")}
                                                       key={"td_"+ds.title+"_"+model.title} >
                                                {model["datasets"][ds.title][selected_metric]}</td>
                                        })}
                                    </tr>)
                                })}
                                </tbody>

                            </table>
                        </div>

                    </div>
                }

            </div>

        )
    }
}

export default OverviewTable;